import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { ResolvedCategory } from '@twisto/api-cms'

import { CategoryBox } from 'homepage/components/category-box'

import * as styles from './subcategories.styles'

export const Subcategories = ({ path, name, categories }: ResolvedCategory) => (
  <nav key={path} aria-label={name}>
    <Typography
      color="textPrimary"
      component="h2"
      css={styles.headline}
      fontWeight="heavy"
      variant="h2"
    >
      {name}
    </Typography>
    <ul css={styles.grid}>
      {categories?.map((subCategory) => (
        <li key={subCategory.path}>
          <CategoryBox
            description={subCategory.description}
            icon={subCategory.icon}
            name={subCategory.name}
            path={subCategory.path}
          />
        </li>
      ))}
    </ul>
  </nav>
)
